import React, { ReactChild } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useStyeguideCtx } from "./docs-layout";
import { ExampleRender } from "./example-render";
import * as scss from "./example.scss";

export type ExampleProps = {
	fn: () => JSX.Element;
	customBar?: (p: { id: string }) => ReactChild;
};

let idCounter = 0;

export function Example(props: ExampleProps): JSX.Element {
	const { fn, customBar } = props;
	const { absolutePath } = useStyeguideCtx();

	const id = `example-${idCounter++}`;

	const allDocPages = useDocPages();
	const ourFile = allDocPages.find((n) => n.parent.absolutePath === absolutePath)!;
	const ourGuy = ourFile.exampleSources.find((n) => n.fnName === fn.name)?.fnBody;
	return (
		<div id={id} className={scss.container}>
			<ExampleRender
				code={ourGuy ?? "no code :("}
				showCodeInitial={!!ourGuy}
				customBar={customBar && customBar({ id })}
			>
				{fn()}
			</ExampleRender>
		</div>
	);
}

const useDocPages = () => useStaticQuery<QueryData>(query).allFancyDocPage.nodes;
type QueryData = {
	allFancyDocPage: {
		nodes: {
			parent: {
				absolutePath: string;
			};
			exampleSources: {
				fnBody: string;
				fnName: string;
			}[];
		}[];
	};
};
const query = graphql`
	query SourceExamplesQuery {
		allFancyDocPage {
			nodes {
				parent {
					... on File {
						absolutePath
					}
				}
				exampleSources {
					fnBody
					fnName
				}
			}
		}
	}
`;
